import { useEffect } from "react";

const useLoadSupPositionToEdit = (
  positiontoedit,
  setToggleClearSF,
  toggleClearSF,
  axiosPrivate,
  navigate,
  location,
  setPosition,
  setPositionData,
  setPaymentterm,
  setPaymenttermData,
  paytermInit,
  paytermDataInit,
  editing,
  setEditingGeneral,
  editingPayterms,
  editingContainer,
  editingBulk,
  setEditingPayterms,
  setEditingContainer,
  setEditingBulk,
  editingGeneral,
  setContaineroptions,
  setContaineroptionsData,
  setBulkoptions,
  setBulkoptionsData,
  setShowPSearch,
  reloadposition,
  setEditing
) => {
  useEffect(() => {
    if (positiontoedit) {
      setToggleClearSF(!toggleClearSF);
      const loadpositiontoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadpositiontoedit", {
            positionID: positiontoedit,
          });
          setPosition(response.data[0]);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadpositiondatatoedit = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadpositiondatatoedit", {
            positionID: positiontoedit,
          });
          setPositionData(response.data[0]);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      if (!editing || editingGeneral) {
        loadpositiontoedit();
        loadpositiondatatoedit();
        setEditingGeneral(false);
      }
      const loadpospayterms = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadpospayterms", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymentterm(paytermInit);
          } else setPaymentterm(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadpospaytermsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadpospaytermsdata", {
            positionID: positiontoedit,
          });
          if (response.data.message === "No payterms exist.") {
            setPaymenttermData(paytermDataInit);
          } else setPaymenttermData(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      if (!editing || editingPayterms) {
        loadpospayterms();
        loadpospaytermsdata();
        setEditingPayterms(false);
      }
      const loadposcontaineroptions = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadposshipoptions", {
            positionID: positiontoedit,
            type: "container",
          });
          if (response.data.message === "No options exist.") {
            setContaineroptions([]);
          } else setContaineroptions(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadposcontaineroptionsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadposshipoptionsdata", {
            positionID: positiontoedit,
            type: "container",
          });
          if (response.data.message === "No options exist.") {
            setContaineroptionsData([]);
          } else setContaineroptionsData(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      if (!editing || editingContainer) {
        loadposcontaineroptions();
        loadposcontaineroptionsdata();
        setEditingContainer(false);
      }
      const loadposbulkoptions = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadposshipoptions", {
            positionID: positiontoedit,
            type: "bulk",
          });
          if (response.data.message === "No options exist.") {
            setBulkoptions([]);
          } else setBulkoptions(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      const loadposbulkoptionsdata = async () => {
        try {
          const response = await axiosPrivate.post("/api/positions/loadposshipoptionsdata", {
            positionID: positiontoedit,
            type: "bulk",
          });
          if (response.data.message === "No options exist.") {
            setBulkoptionsData([]);
          } else setBulkoptionsData(response.data);
        } catch (err) {
          navigate("/login", { state: { from: location }, replace: true });
        }
      };
      if (!editing || editingBulk) {
        loadposbulkoptions();
        loadposbulkoptionsdata();
        setEditingBulk(false);
      }
      setShowPSearch(false);
      setEditing(true);
    }
  }, [positiontoedit, reloadposition]);
};

export default useLoadSupPositionToEdit;
